import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useLinkButtonData } from './hooks';
import { trackPromoNewbuildingListingClickAction } from '../../../actions/analytics';
import { NewbuildingsLink } from '../../../components/redesign/NewbuildingsLink';
import { EPromoType } from '../../../types/promos/promoType';
import { TThunkDispatch } from '../../../types/redux/thunk';

interface INewbuildingLinkContainerProps {
  promoId: string;
  promoType: EPromoType;
  newbuildingIds: number[];
}

export const NewbuildingLinkContainer = ({ promoId, promoType, newbuildingIds }: INewbuildingLinkContainerProps) => {
  const { url, textImage } = useLinkButtonData(promoType, newbuildingIds);

  const dispatch: TThunkDispatch = useDispatch();

  const handleLinkClick = React.useCallback(() => {
    dispatch(trackPromoNewbuildingListingClickAction(promoId));
  }, [dispatch, promoId]);

  return <NewbuildingsLink onClick={handleLinkClick} url={url} textImage={textImage} />;
};
